import React, { useState } from "react";

import Input from "../../atoms/input/input";
import Button from "../../atoms/button/button";
import { normalizeTwoWords, formatImageAlt } from "../../../shared/utils/stringUtilities";
import imageDefault from "../../../assets/images/author-default.jpeg"

import "./recommendedAuthor.scss";
interface RecommenderSectionProps {
  title: string;
  subtitle: string;
  cardsInfo: Array<any>;
  skipBtnText: string;
  nextBtnText: string;
  finishText: string;
  selected: number;
  handleSelections: any;
  nextBtnEnable: boolean;
  nextBtnFunction: any;
  skipBtnFunction: any;
  finishFunction: any;
  finishEnable?: boolean;
  gtmName?: string;
}

interface AuthorProps {
  imageUrl: string;
  title: string;
  className?: string;
  handler?: any;
  isSelected?: number;
  idx: number;
}

const Author = (props: AuthorProps) => {
  return (
    <div
      className={"m-recommended-author__authors-author " + `gtmRecomendadorClicAutor${normalizeTwoWords(props.title)}` }
      onClick={props.handler}
    >
      <img
        className="m-recommended-author__authors-author__image"
        src={props.imageUrl}
        alt={formatImageAlt(props.title)}
      />

      <p className="m-recommended-author__authors-author__name">
        {props.title}
      </p>

      <div
        className={`m-recommended-author__authors-author__checked ${
          props.className
        } ${props.isSelected === props.idx ? "selected" : "unselected"}`}
      >
        <div className="m-recommended-author__authors-author__checked-icon icon-check"></div>
      </div>
    </div>
  );
};

const RecommendedAuthor = (props: RecommenderSectionProps) => {
  const [selected, setSelected] = useState(false);
  const [selecIdx, setSelectIdx] = useState(-1);
  const [selectedAuthor, setSelectedAuthor] = useState({
    name: "",
    imageUrl: imageDefault,
  });

  const handleSelection = (event, className, idx) => {
    const { alt, innerHTML } = event.target;
    setSelectIdx(idx);

    if (selected) {
      return;
    }

    Array.from(
      document.getElementsByClassName(
        "m-recommended-author__authors-author__checked"
      )
    ).forEach((elem) => {
      elem.classList.remove("selected");
      elem.classList.add("unselected");
    });

    if (typeof alt === "undefined") {
      setSelectIdx(-1);
      props.handleSelections(-1);
      return setSelected(false);
    }

    setSelectedAuthor((author) => {
      author.name = alt ? alt : innerHTML;

      props.handleSelections(author.name);
      return author;
    });

    document.getElementsByClassName(className)[0].classList.add("selected");
    document
      .getElementsByClassName(className)[0]
      .classList.remove("unselected");
  };

  const handleSelectionInput = (event, selectedValue = true) => {
    const { alt, innerHTML } = event.target;

    if (selectedValue) {
      return setSelected(false);
    }

    setSelectedAuthor((author) => {
      author.name = alt ? alt : innerHTML;
      props.handleSelections(author.name);
      return author;
    });
    setSelected(true);
  };

  return (
    <div className="m-recommended-author">
      <p className="m-recommended-author__title">{props.title}</p>
      <p className="m-recommended-author__description">{props.subtitle}</p>

      <div className="m-recommended-author__input">
        <Input
          cardsInfo={props.cardsInfo}
          handleSelection={handleSelectionInput}
          isSelected={setSelected}
          disableSelection={props.handleSelections}
        />
      </div>

      <div className="m-recommended-author__authors">
        {!selected ? (
          props.cardsInfo.map((e, idx) => {
            return (
              <Author
                key={idx}
                imageUrl={e.imagenPrincipal[0].file.url}
                title={e.tituloBanner}
                handler={(event) => handleSelection(event, e.tituloBanner, idx)}
                className={`${e.tituloBanner}`}
                isSelected={selecIdx}
                idx={idx}
              />
            );
          })
        ) : (
          <Author
            idx={0}
            imageUrl={selectedAuthor.imageUrl}
            title={selectedAuthor.name}
            className={selectedAuthor.name}
            handler={handleSelection}
            isSelected={0}
          />
        )}
      </div>

      <div className="m-recommended-author__buttons">
        <Button
          type="button"
          classname="m-recommended-author__buttons-back"
          text={props.skipBtnText}
          onClickAction={props.finishFunction}
          isDisabled={!props.finishEnable}
          gtmMark={"gtmRecomendadorClicPasosAutorOmitirPaso"}
        />
        <Button
          type="button"
          classname={"m-recommended-author__buttons-next"}
          text={props.nextBtnText}
          onClickAction={() => props.finishFunction()}
          isDisabled={!props.nextBtnEnable}
          gtmMark={"gtmRecomendadorClicPasosAutorSiguiente"}
        />
      </div>

      <p
        onClick={props.finishEnable ? () => props.finishFunction() : () => true}
        className={`m-recommended-author__advised ${
          !props.finishEnable ? "finish-enable" : ""}
          gtmRecomendadorClicRecomiendameLeer${props.gtmName}`
        }
      >
        {props.finishText}
      </p>
    </div>
  );
};

export default RecommendedAuthor;
